import { OnboardingStep } from '@mnd-frontend/graphql-schema';
import IconAnalyze from '@mnd-frontend/icons/components/Analyze';
import IconCirclePlus from '@mnd-frontend/icons/components/CirclePlus';
import IconCircleUser from '@mnd-frontend/icons/components/CircleUser';
import IconLearningVideo from '@mnd-frontend/icons/components/LearningVideo';
import IconSliders from '@mnd-frontend/icons/components/Sliders';
import IconTextFile from '@mnd-frontend/icons/components/TextFile';
import IconUser from '@mnd-frontend/icons/components/User';
import IconVisibility from '@mnd-frontend/icons/components/Visibility';
import IconWeb from '@mnd-frontend/icons/components/Web';
import type { NavigateFunction } from 'react-router';
import routes from '../../../../../routes';

export const getStepIcon = (step: string) => {
  switch (step) {
    case OnboardingStep.Account:
      return <IconCircleUser />;
    case OnboardingStep.Pressrelease:
      return <IconCirclePlus />;
    case OnboardingStep.Contacts:
      return <IconUser />;
    case OnboardingStep.Preview:
      return <IconWeb />;
    case OnboardingStep.Newsroom:
      return <IconVisibility />;
    case OnboardingStep.PublishPressrelease:
      return <IconTextFile />;
    case OnboardingStep.Analyze:
      return <IconAnalyze />;
    case OnboardingStep.VideoCourses:
      return <IconLearningVideo />;
    default:
      return <IconSliders />;
  }
};

export const getStepAction = ({
  step,
  pressroomId,
  completeStepMutation,
  navigate,
}: {
  step: string;
  pressroomId: string;
  completeStepMutation: (input: any) => void;
  navigate: NavigateFunction;
}) => {
  switch (step) {
    case OnboardingStep.Pressrelease:
    case OnboardingStep.PublishPressrelease:
      return () =>
        navigate(
          routes.publishList({
            pressroomId,
            materialType: 'pressreleases',
          }),
        );
    case OnboardingStep.Contacts:
      return () => navigate(routes.contacts({ pressroomId }));
    case OnboardingStep.Preview:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.Preview } });
        navigate(
          routes.preview({
            pressroomId,
          }),
        );
      };
    case OnboardingStep.Newsroom:
      return () =>
        navigate(
          `${routes.dashboard({
            pressroomId,
          })}?onboarding-step=branding`,
        );
    case OnboardingStep.Analyze:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.Analyze } });
        navigate(
          routes.analyzeOverview({
            pressroomId,
          }),
        );
      };
    case OnboardingStep.VideoCourses:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.VideoCourses } });
        navigate(
          `${routes.dashboard({
            pressroomId,
          })}?onboarding-course=open`,
        );
      };
    case OnboardingStep.Account:
    default:
      return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
  }
};
